import { Button, Modal, Input, Select, Space, InputNumber } from 'antd';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'src/api';
import { toast } from 'react-hot-toast';
import styled from 'styled-components';

const StyledSpace = styled(Space)`
  display: flex;
  width: 100%;

  .ant-space-item:first-child {
    flex-grow: 1;
  }
`;

function CopyHotelCalendar({
  isOpen,
  close,
  selectedCalendar,
  propertyId,
  rooms,
  isFetching,
  propertyType,
  isMobile
}) {
  const [room, setRoom] = useState('');
  const queryClient = useQueryClient();
  const clean = () => {
    close();
  };

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      if (!room && propertyType === 'hotel')
        return toast.error('Room is required');
      const link = `${process.env.REACT_APP_API_URL}/calendar/export-ics/${propertyId}/${room}`;
      window.navigator.clipboard.writeText(link);
      toast.success('Calender Link Copied To Clipboard');
    },
    onError: () => {
      toast.error('Something went wrong');
    }
  });

  const modalStyle = {
    top: isMobile ? 20 : 100,
    maxWidth: isMobile ? '95vw' : '520px',
    margin: isMobile ? '0 auto' : undefined
  };

  const headingStyle = {
    fontSize: isMobile ? '14px' : '16px',
    margin: isMobile ? '0 0 5px 0' : '0 0 8px 0',
    fontWeight: 500
  };

  const controlSize = isMobile ? 'middle' : 'large';

  return (
    <Modal
      open={isOpen}
      title={''}
      onCancel={clean}
      footer={[
        <Button key="back" onClick={clean} disabled={isPending} size={controlSize}>
          Cancel
        </Button>,
        <Button
          key="link"
          type="primary"
          disabled={isPending}
          loading={isPending}
          onClick={mutate}
          form="sync-calendar"
          size={controlSize}
        >
          Save
        </Button>
      ]}
      style={modalStyle}
      width={isMobile ? '95%' : 520}
      maskClosable={!isPending}
      destroyOnClose
      centered={!isMobile}
    >
      {!!selectedCalendar ? (
        <div style={{ padding: isMobile ? '10px 0' : '15px 0' }}>
          {propertyType === 'hotel' && (
            <>
              <StyledSpace>
                <Space size={0} direction="vertical" style={{ width: '100%' }}>
                  <h4 style={headingStyle}>Room</h4>
                  <Input
                    disabled
                    size={controlSize}
                    placeholder={
                      rooms.find(item => item.roomTypeId === room)?.roomName ||
                      ''
                    }
                  />
                </Space>
              </StyledSpace>
            </>
          )}
        </div>
      ) : (
        <div style={{ padding: isMobile ? '10px 0' : '15px 0' }}>
          {propertyType === 'hotel' && (
            <StyledSpace>
              <Space size={0} direction="vertical" style={{ width: '100%' }}>
                <h4 style={headingStyle}>Room Type</h4>
                <Select
                  size={controlSize}
                  style={{
                    width: '100%'
                  }}
                  loading={isFetching}
                  placeholder="Select a room"
                  onChange={val => setRoom(val)}
                  options={rooms.map(item => ({
                    value: item.roomTypeId,
                    label: item?.displayName + " - " + item?.roomName
                  }))}
                  dropdownMatchSelectWidth={!isMobile}
                  listHeight={isMobile ? 200 : 256}
                />
              </Space>
            </StyledSpace>
          )}
        </div>
      )}
    </Modal>
  );
}

export default CopyHotelCalendar;